// extracted by mini-css-extract-plugin
export var activeFilterButton = "_p6-c";
export var backButton = "_p6-4";
export var backIcon = "_p6-5";
export var chevronShortcut = "_p6-6";
export var container = "_p6-1";
export var editor = "_p6-8";
export var editorWrapper = "_p6-7";
export var prefix = "_p6-2";
export var searchIcon = "_p6-3";
export var suffix = "_p6-9";
export var suffixContent = "_p6-a";
export var suffixText = "_p6-b";
export var wrapper = "_p6-0";